export const messages = {
  en: {
    doOrderDetailIn: {
      title: 'Confirm Storage',
      orderId: 'Order ID',
      applicant: 'Applicant',
      applyTime: 'Apply Time',
      orderStatus: 'Order Status',
      remark: 'Remark',
      productInfo: 'Product Information',
      serialNumber: 'No.',
      productName: 'Product Name',
      productCode: 'Product Code',
      specification: 'Specification',
      applyQuantity: 'Apply Quantity',
      actualQuantity: 'Actual Quantity',
      price: 'Price',
      amount: 'Amount',
      operation: 'Operation',
      cancelStorage: 'Cancel Storage',
      canceled: 'Canceled',
      confirmStorage: 'Confirm Storage',
      cancelOrder: 'Cancel Order',
      back: 'Back'
    }
  },
  zh: {
    doOrderDetailIn: {
      title: '确定入库',
      orderId: '工单编码',
      applicant: '申请人',
      applyTime: '申请时间',
      orderStatus: '订单状态',
      remark: '备注',
      productInfo: '商品信息',
      serialNumber: '序号',
      productName: '商品名称',
      productCode: '商品编号',
      specification: '规格',
      applyQuantity: '申请单数量',
      actualQuantity: '实际数量',
      price: '价格',
      amount: '金额',
      operation: '操作',
      cancelStorage: '取消入库',
      canceled: '已取消',
      confirmStorage: '确定入库',
      cancelOrder: '取消入库单',
      back: '返回'
    }
  }
}